import { ConfigClient } from '@/modules/client-config/domain/models/ConfigClient'

import { axios, Response } from '../index'

export default async function getCAAConfig(
  patientId: string
): Response<ConfigClient> {
  return axios.get(`/v1/patient/${patientId}/caa-config`)
}
